import script from "./Notifications.vue?vue&type=script&lang=ts&setup=true"
export * from "./Notifications.vue?vue&type=script&lang=ts&setup=true"

import "./Notifications.vue?vue&type=style&index=0&id=2bafcffa&lang=sass"

const __exports__ = script;

export default __exports__